import ReactDOM from "react-dom";

const ModalWrapper = ({ children }) => {
  const modalRoot = document.getElementById("modal-root");
  if (!modalRoot) {
    return <div>{children}</div>;
  }

  return ReactDOM.createPortal(<div>{children}</div>, modalRoot);
};

export default ModalWrapper;
